(function(window){

    var WORKER_PATH = window.isNFT ? 'recorderWorker.js' : '../recorderWorker.js';

  var Recorder = function(source, cfg){
    var config = cfg || {};
    var bufferLen = config.bufferLen || 256;
    var numChannels = config.numChannels || 2;
    this.context = source.context;
    this.node = (this.context.createScriptProcessor ||
                 this.context.createJavaScriptNode).call(this.context,
                 bufferLen, numChannels, numChannels);
    var worker = new Worker(config.workerPath || WORKER_PATH);
    worker.postMessage({
      command: 'init',
      config: {
        sampleRate: this.context.sampleRate,
        numChannels: numChannels
      }
    });
    var recording = false,
        currCallback;

      var skip = true;

      var startedRecording, stoppedRecording= null;
      var lastTime = 0;

    this.node.onaudioprocess = function(e){
        if (!recording) return;
        let samplesToSkipAtFront = 0;
        if (startedRecording != null) {
            /**
             * buffer: (this.contet.currentTime - bufferlen/sr)_______START________this.context.currentTime
             * the points before start need to be killed
             */
            if (skip) {
                let seconds = startedRecording - lastTime;
                lastTime = this.context.currentTime;
                samplesToSkipAtFront = Math.floor(seconds * this.context.sampleRate) - 120;
                
                if (samplesToSkipAtFront < 0 || samplesToSkipAtFront > bufferLen) {
                    return;
                }
            }
            startedRecording = null;
        }
        if (stoppedRecording !== null) {
            let seconds = this.context.currentTime - stoppedRecording;
            if (seconds >= 0) {
                stoppedRecording = null;
                recording = false;
            } 
        }
        var buf = [];
        for (var channel = 0; channel < numChannels; channel++){
            let channelData = e.inputBuffer.getChannelData(channel);
            if (samplesToSkipAtFront > 0) {
                channelData = channelData.subarray(samplesToSkipAtFront);
            }
            buf.push(channelData);
        }
        worker.postMessage({
            command: 'record',
            buffer: buf 
        })
    }

      this.terminate = function() {
          worker.terminate();
      }

    this.configure = function(cfg){
      for (var prop in cfg){
        if (cfg.hasOwnProperty(prop)){
          config[prop] = cfg[prop];
        }
      }
    }

    this.record = function(milliseconds){
        if (milliseconds !== undefined) {
            startedRecording = milliseconds;
            skip = true;
        } else {
            startedRecording = this.context.currentTime;
            skip = false;
        }
      recording = true;
        stoppedRecording = undefined;
    }

    this.stop = function(milliseconds){
        if (milliseconds !== undefined) {
            stoppedRecording = milliseconds;
        } else {
            stoppedRecording = new Date().getTime();
        }
    }

      this.clear = function(time=new Date().getTime()){
          startedRecording = time;
          worker.postMessage({ command: 'clear' });
    }

    this.getBuffer = function(cb) {
      currCallback = cb || config.callback;
      worker.postMessage({ command: 'getBuffer' })
    }

    this.exportWAV = function(cb, type){
      currCallback = cb || config.callback;
      type = type || config.type || 'audio/wav';
      if (!currCallback) throw new Error('Callback not set');
      worker.postMessage({
        command: 'exportWAV',
        type: type
      });
    }

    worker.onmessage = function(e){
      var blob = e.data;
      currCallback(blob);
    }

    source.connect(this.node);
    var gainNode = this.context.createGain();
    gainNode.gain.value = 0;
    this.node.connect(gainNode);
    gainNode.connect(this.context.destination);
  };

  Recorder.forceDownload = function(blob, filename){
    var url = (window.URL || window.webkitURL).createObjectURL(blob);
    var link = window.document.createElement('a');
    link.href = url;
    link.download = filename || 'output.wav';
    var click = document.createEvent("Event");
    click.initEvent("click", true, true);
    link.dispatchEvent(click);
  }

  window.Recorder = Recorder;
})(window);
